import * as React from 'react';
import { toast } from 'react-toastify';
import DriverJobsSiteDeparturePlanChangesData from './DriverJobsSiteDeparturePlanChanges';

interface DriverJobsSiteDeparturePartProps {
    partCompleteJob: PartCompleteJob;
    back(): void;
    update(partCompleteJob: PartCompleteJob): void;
    next(): void;
}
interface DriverJobsSiteDeparturePart {
    loading: boolean;
    showValidation: boolean;
    errors: any;
}

interface PartCompleteJob {
    planChanges: PlanChanges;
    jobItems: DriverJobItems[];
    notes: string;
}

interface DriverJobItems {
    id: number;
    kwikstageId: number;
    unitNumberDisplay: string;
    type: string;
    typeId: number;
    item: string;
    itemId: number;
    quantity: number;
    itemQuantityType: string;
    estimatedTime: string;
    estimatedTimeMins: number;
    isComplete: boolean;
    percentComplete: number;    //used for Kwikstage
    vehicleItemOrder: number;   //used when adding manual job after a linked job
    itemParts: ItemPart[];
    other: boolean;
    otherDisabled: boolean;
}

interface ItemPart {
    itemPartId: number;
    part: string;
    isComplete: boolean;
}

interface PlanChanges {
    planChanges: number;
    plan: File,
    planComments: string;
    notes: string;
}

export default class DriverJobsSiteDeparturePartData extends React.Component<DriverJobsSiteDeparturePartProps, DriverJobsSiteDeparturePart> {
    constructor(props: DriverJobsSiteDeparturePartProps) {
        super(props);

        this.state = {
            loading: false,
            showValidation: false,
            errors: {}
        };
    }

    componentDidMount() {
        window.scrollTo(0, 0);
    }

    back = (e: any) => {
        e.preventDefault();

        this.props.back();
    }

    updatePlanChanges = (planChanges: PlanChanges, fieldName: string) => {
        var errors = this.state.errors;
        if (fieldName) {
            delete errors[fieldName];
        }
        var partJob = this.props.partCompleteJob;
        partJob.planChanges = planChanges;
        this.props.update(partJob);
    }

    validate = () => {
        //check if all jobs are pickup
        var totalItems = this.props.partCompleteJob.jobItems.length;
        var pickupItems = this.props.partCompleteJob.jobItems.filter(j => j.typeId === 2).length;
        var isPickup = totalItems === pickupItems;
        var partJob = this.props.partCompleteJob;
        let jobItems = partJob.planChanges;
        let errors: any = {};
        let formIsValid = true;

        if (isPickup) {
            jobItems.planChanges = 0;
            this.props.update(partJob);
        } else {
            var planChanges = jobItems.planChanges * 1;
            if (planChanges < 0) {
                formIsValid = false;
                errors["planChanges"] = "Plan Changes is required";
            } else if (planChanges === 1) {
                if (jobItems.plan.size === 0) {
                    formIsValid = false;
                    errors["plan"] = "You must upload a photo of the plan changes";
                }
                if (!jobItems.planComments) {
                    formIsValid = false;
                    errors["planComments"] = "Plan Comments are required";
                }
            }
        }

        this.setState({ errors: errors });
        return formIsValid;
    }

    next = (e: any) => {
        e.preventDefault();
        if (this.validate()) {
            this.props.next();
        } else {
            toast.error("Please fix validation errors!");
        }
    }

    render() {
        let contents = this.state.loading
            ? <p><em>Loading...</em></p>
            : this.renderDetails();

        return <div>
            {contents}
        </div>;
    }

    renderDetails = () => {
        var totalItems = this.props.partCompleteJob.jobItems.length;
        var pickupItems = this.props.partCompleteJob.jobItems.filter(j => j.typeId === 2).length;
        var isPickup = totalItems === pickupItems;
        let planChangesQuestions = <DriverJobsSiteDeparturePlanChangesData planChanges={this.props.partCompleteJob.planChanges} isPickup={isPickup} errors={this.state.errors} update={this.updatePlanChanges} />

        return (
            <div>
                <div className="mobileFont marginTop10 marginBottom10">
                    <div className="makeitflexspacebetween marginBottom10">
                        <h2 className="mobile-margin">Job Partially Complete</h2>
                        <i className="mobile-icon-grey fas fa-arrow-alt-circle-left mobileMenuSize" onClick={(e) => this.back(e)}></i>
                    </div>
                    {planChangesQuestions }
                    
                    <div className="defaultbutton__container--right marginTop10">
                        <i className="mobile-icon-green fas fa-arrow-alt-circle-right mobileMenuSize" onClick={(e) => this.next(e)}></i>
                    </div>
                </div>
            </div>
        );

    }
}
